import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { FlexRow, FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const { carbon } = colorsPalettes;

export const PieContainer = styled(FlexRow)`
    height: 100%;
    gap:6px;
    padding-top: 12px;
    justify-content: space-between;
`;

export const PieValueContainer = styled(FlexColumn)`
    gap: 16px;
`;


export const Label = styled.div`
    ${setFontVariant("caption", carbon[300])};
    white-space: nowrap;
`;
export const PieCategoryContainer = styled.div`
    display: grid;
    grid-template-columns: auto 1fr; 
    grid-template-rows: auto auto;
    align-items: center;
    row-gap: 4px;
`
export const PieValue = styled.p`
    margin: 0;
    grid-column: 2;
    ${setFontVariant("h5", carbon[500])}
`;

export const Marker = styled.span<{ backgroundColor: string }>`
    flex-shrink: 0;
    background: ${({ backgroundColor }) => backgroundColor};
    border-radius: 100%;
    height: 12px;
    width: 12px;
    margin-right: 8px;
    display: block;
`;
